import React from 'react'
import { useAuth } from '../../components/auth/useAuth'

export default function CabeceraMovil({title,icon = null,logo = '/images/logotipo-rumiantec.jpg'}) {
    const {clientauth} = useAuth()
  	return (
        <div id="cabecera" className="position-fixed top-0 start-0 w-100 d-sm-none">
            <h1 className="font-general text-white">{title}</h1>
            <div>{clientauth?.name}</div>
			<div className='text-center my-2'>
				<img id='logo' className='mx-auto' src={logo} alt='logo'/>
			</div>
        </div>
	)
}